import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { AppBootstrap } from './components/AppBootstrap';
import { buildOidcConfig } from './lib/auth';
import { loadRuntimeConfig } from './runtimeConfig';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('#root element not found in index.html');
}
const root = createRoot(rootElement);

async function bootstrap(): Promise<void> {
  await loadRuntimeConfig();
  const oidcConfig = buildOidcConfig();

  root.render(
    <StrictMode>
      <AuthProvider {...oidcConfig}>
        <AppBootstrap />
      </AuthProvider>
    </StrictMode>,
  );
}

bootstrap().catch((error: unknown) => {
  console.error('Fatal: application bootstrap failed', error);

  const message = error instanceof Error ? error.message : String(error);
  root.render(
    <div role="alert" style={{ padding: '2rem', fontFamily: 'system-ui, sans-serif' }}>
      <h1>Configuration error</h1>
      <p>The application could not load its runtime configuration and cannot start.</p>
      <pre style={{ whiteSpace: 'pre-wrap' }}>{message}</pre>
    </div>,
  );
});
